<template>
<div>
    INSPECCIONES
</div>
</template>

<script>
export default {

    data() {
        return {

        }
    },

    mounted() {}
}
</script>
